import axios from 'axios'
import cookie from '~/utils/cookie'

export const baseURL = {
  'production': 'https://xueshi-service.yoyohr.com',
  'lan': 'http://xueshicloud-service.youpin-k8s.net',
  'development': 'http://192.168.1.17:9903'
  // 私有项目端口
  // 'development': 'http://192.168.1.17:10241'
  // 'development': 'http://9903.lan.sakuraio.com'
}[process.env.NODE_ENV]

// 李纲
export const projectId = {
  'production': '1d77558ee7c725846683657dce456fcb',
  // 内网版本id
  'lan': '7b7518b8388dbe47271c03bea066cc3e',
  'development': '1d77558ee7c725846683657dce456fcb'
}[process.env.NODE_ENV]

// 测试
// export const projectId = {
//   'production': '25d37489c928426769083b75a73eade3',
//   'lan': '25d37489c928426769083b75a73eade3',
//   'development': '25d37489c928426769083b75a73eade3'
// }[process.env.NODE_ENV]

// 私有部署的项目id 吴江
// export const projectId = {
//   'production': '32fb765b55210c42ce5d41d1f3580ebf',
//   'lan': '32fb765b55210c42ce5d41d1f3580ebf',
//   'development': '32fb765b55210c42ce5d41d1f3580ebf'
// }[process.env.NODE_ENV]

const eid = cookie.get('eid')

// 30秒中断请求
axios.defaults.timeout = 30000

// 拦截发送请求
axios.interceptors.request.use(
  config => {
    let token = cookie.get('token')
    token && (config.headers.Authorization = 'Bearer ' + token)
    let deviceId = cookie.get('device_id')
    deviceId && (config.headers.DeviceId = deviceId)
    // 加入projectId
    config.headers['X-PID'] = projectId
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 拦截返回结果
axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      let token
      if (res.headers && res.headers.authorization) {
        token = res.headers.authorization.substr(7)
        cookie.set('token', token)
      }
      if (res.data.code === 10127 || res.data.code === 10126 || res.data.code === 10117) {
        // token失效
        cookie.remove('token')
        cookie.remove('device_id')
        location.href = '/login'
      }
    }
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * request封装
 */
function fetchData (method, url, data = {}) {
  return new Promise((resolve, reject) => {
    let request
    eid && (data.current_eid = eid)
    if (method === 'get' || method === 'delete') {
      request = axios[method](baseURL + url, { params: data })
    } else {
      request = axios[method](baseURL + url, data)
    }
    request
      .then(res => {
        resolve(res)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export function get (url, params) {
  return fetchData('get', url, params)
}

export function post (url, data) {
  return fetchData('post', url, data)
}

export function put (url, data) {
  return fetchData('put', url, data)
}

export function remove (url, params) {
  return fetchData('delete', url, params)
}

export function upload (url, data) {
  const formData = new FormData()
  Object.keys(data).forEach((child) => {
    formData.append(child, data[child])
  })
  return post(url, formData)
}



// WEBPACK FOOTER //
// ./src/api/config.js